<template>
  <v-container>
    <v-layout
      row
      pt-10
    >
      <v-flex
        xs12
        sm6
        offset-sm3
      >
        <h2
          class="primary--text"
        >
          Register a Showcase Piece
        </h2>
      </v-flex>
    </v-layout>
    <v-layout>
      <v-flex
        xs12
      >
        <form @submit.prevent="onCreatePiece">
          <v-layout
            row
          >
            <v-flex
              xs12
              sm6
              offset-sm3
            >
              <v-text-field
                id="title"
                v-model="title"
                name="title"
                label="Variation or Song Title"
                required
              />
              <v-text-field
                id="song-artist"
                v-model="songArtist"
                name="song-artist"
                label="Song Artist"
                required
              />
              <v-select
                id="pieceType"
                v-model="pieceType"
                name="pieceType"
                label="pieceType"
                :items="pieceTypes"
                required
              />
              <v-checkbox
                id="musicReceived"
                v-model="musicReceived"
                name="musicReceived"
                label="Music Received"
              />
              <v-text-field
                v-if="musicReceived === true"
                id="lengthInSeconds"
                v-model="lengthInSeconds"
                name="lengthInSeconds"
                label="Length (In Seconds)"
                type="number"
              />
              <v-select
                id="groupSize"
                v-model="groupSize"
                name="groupSize"
                label="groupSize"
                :items="groupSizes"
                required
              />
              <p
                v-if="groupSize && groupSize !== 'Solo'"
                class="caption grey--text"
                style="margin-top: -4px; margin-bottom: 12px;"
              >
                Music is split evenly among the dancers on this piece toward each person’s 5½ minutes.
              </p>
              <v-select
                id="dancer1"
                v-model="dancer1"
                name="dancer1"
                label="dancer1"
                item-text="name"
                item-value="id"
                :items="allDancers"
                required
              />
              <v-select
                v-if="groupSize === 'Duet/Pas de Deux' || groupSize === 'Trio' || groupSize === '4-12 Dancers'"
                id="dancer2"
                v-model="dancer2"
                name="dancer2"
                label="dancer2"
                item-text="name"
                item-value="id"
                :items="allDancers"
              />
              <v-select
                v-if="groupSize === 'Trio'"
                id="dancer3"
                v-model="dancer3"
                name="dancer3"
                label="dancer3"
                item-text="name"
                item-value="id"
                :items="allDancers"
              />
              <v-select
                v-if="groupSize === '4-12 Dancers'"
                id="dancer4"
                v-model="dancer4"
                name="dancer4"
                label="dancer4"
                item-text="name"
                item-value="id"
                :items="allDancers"
              />
              <v-select
                v-if="groupSize === '4-12 Dancers'"
                id="dancer5"
                v-model="dancer5"
                name="dancer5"
                label="dancer5"
                item-text="name"
                item-value="id"
                :items="allDancers"
              />
              <v-select
                v-if="groupSize === '4-12 Dancers'"
                id="dancer6"
                v-model="dancer6"
                name="dancer6"
                label="dancer6"
                item-text="name"
                item-value="id"
                :items="allDancers"
              />
              <v-select
                v-if="groupSize === '4-12 Dancers'"
                id="dancer7"
                v-model="dancer7"
                name="dancer7"
                label="dancer7"
                item-text="name"
                item-value="id"
                :items="allDancers"
              />
              <v-select
                v-if="groupSize === '4-12 Dancers'"
                id="dancer8"
                v-model="dancer8"
                name="dancer8"
                label="dancer8"
                item-text="name"
                item-value="id"
                :items="allDancers"
              />
              <v-select
                v-if="groupSize === '4-12 Dancers'"
                id="dancer9"
                v-model="dancer9"
                name="dancer9"
                label="dancer9"
                item-text="name"
                item-value="id"
                :items="allDancers"
              />
              <v-select
                v-if="groupSize === '4-12 Dancers'"
                id="dancer10"
                v-model="dancer10"
                name="dancer10"
                label="dancer10"
                item-text="name"
                item-value="id"
                :items="allDancers"
              />
              <v-select
                v-if="groupSize === '4-12 Dancers'"
                id="dancer11"
                v-model="dancer11"
                name="dancer11"
                label="dancer11"
                item-text="name"
                item-value="id"
                :items="allDancers"
              />
              <v-select
                v-if="groupSize === '4-12 Dancers'"
                id="dancer12"
                v-model="dancer12"
                name="dancer12"
                label="dancer12"
                item-text="name"
                item-value="id"
                :items="allDancers"
              />
              <v-text-field
                id="programDancer"
                v-model="programDancer"
                name="programDancer"
                label="Dancer Name(s) for the Program"
              />
              <v-text-field
                id="programTeacher"
                v-model="programTeacher"
                name="programTeacher"
                label="Teacher/Choreographer Name for the Program"
              />
              <v-text-field
                id="programTitle"
                v-model="programTitle"
                name="programTitle"
                label="Title for the Program"
              />
            </v-flex>
          </v-layout>
          <v-layout
            row
            pt-5
          >
            <v-flex
              xs12
              sm6
              offset-sm3
            >
              <p
                v-if="saveError"
                class="error--text"
                role="alert"
                style="margin-bottom: 12px;"
              >
                {{ saveError }}
              </p>
              <v-btn
                class="primary"
                :disabled="!formIsValid || saving"
                :loading="saving"
                type="submit"
              >
                Create Piece & Add Another
              </v-btn>
            </v-flex>
          </v-layout>
        </form>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import iabfAdminMixin from '@/utils/iabf-admin-mixin'
import { db } from '@/firebase'
import { assertStageTimeOk } from '@/utils/iabf-stage-time'

  export default {
    mixins: [iabfAdminMixin],
    data () {
      return {
        saveError: '',
        saving: false,
        pieceTypes: ['Classical Variation', 'Original Ballet Choreography', 'Contemporary/Lyrical Ballet', 'Jazz'],
        groupSizes: ['Solo', 'Duet/Pas de Deux', 'Trio', '4-12 Dancers'],
        allDancers: [],
        title: '',
        songArtist: '',
        programDancer: '',
        programTeacher: '',
        programTitle: '',
        musicReceived: false,
        lengthInSeconds: '',
        pieceType: '',
        groupSize: '',
        dancer1: '',
        dancer2: '',
        dancer3: '',
        dancer4: '',
        dancer5: '',
        dancer6: '',
        dancer7: '',
        dancer8: '',
        dancer9: '',
        dancer10: '',
        dancer11: '',
        dancer12: ''
      }
    },
    created () {
      this.$store.dispatch('loadIABFDancers').then(() => {
        this.$store.getters.loadedIABFDancers.forEach(dancer => {
          this.allDancers.push({
            id: dancer.id,
            name: dancer.firstName + ' ' + dancer.lastName
          })
        })
        this.allDancers.sort((a, b) => {
          if (a.name < b.name) {
            return -1
          }
          if (a.name > b.name) {
            return 1
          }
          return 0
        })
      })
    },
    computed: {
      formIsValid () {
        return this.title !== '' && this.songArtist !== '' && this.pieceType !== '' && this.groupSize !== '' && this.dancer1 !== ''
      }
    },
    methods: {
      formDancerIds () {
        return [
          this.dancer1, this.dancer2, this.dancer3, this.dancer4, this.dancer5, this.dancer6,
          this.dancer7, this.dancer8, this.dancer9, this.dancer10, this.dancer11, this.dancer12
        ].filter(Boolean)
      },
      dancerNameForId (id) {
        const found = this.allDancers.find(d => d.id === id)
        return found ? found.name : ''
      },
      async yearPiecesForValidation () {
        if (this._yearPieces && this._yearPieces.length) {
          return this._yearPieces
        }
        const snap = await db.collection(this.IABF.pieces).get()
        this._yearPieces = snap.docs.map((doc) => ({ id: doc.id, ...(doc.data() || {}) }))
        return this._yearPieces
      },
      async onCreatePiece () {
        if (!this.formIsValid) {
          return
        }
        this.saveError = ''
        this.saving = true
        try {
          const allPieces = await this.yearPiecesForValidation()
          const check = assertStageTimeOk({
            allPieces,
            proposedPiece: {
              dancers: this.formDancerIds(),
              lengthInSeconds: this.lengthInSeconds
            },
            nameForId: (id) => this.dancerNameForId(id)
          })
          if (!check.ok) {
            this.saveError = check.error
            this.saving = false
            return
          }
          const pieceData = {
            title: this.title,
            songArtist: this.songArtist,
            programDancer: this.programDancer,
            programTeacher: this.programTeacher,
            programTitle: this.programTitle,
            musicReceived: this.musicReceived,
            lengthInSeconds: this.lengthInSeconds,
            pieceType: this.pieceType,
            groupSize: this.groupSize,
            dancer1: this.dancer1,
            dancer2: this.dancer2,
            dancer3: this.dancer3,
            dancer4: this.dancer4,
            dancer5: this.dancer5,
            dancer6: this.dancer6,
            dancer7: this.dancer7,
            dancer8: this.dancer8,
            dancer9: this.dancer9,
            dancer10: this.dancer10,
            dancer11: this.dancer11,
            dancer12: this.dancer12
          }
          await this.$store.dispatch('createIABFPiece', pieceData)
          this._yearPieces = null
          this.title = ''
          this.songArtist = ''
          this.programDancer = ''
          this.programTeacher = ''
          this.programTitle = ''
          this.musicReceived = false
          this.lengthInSeconds = ''
          this.pieceType = ''
          this.groupSize = ''
          this.dancer1 = ''
          this.dancer2 = ''
          this.dancer3 = ''
          this.dancer4 = ''
          this.dancer5 = ''
          this.dancer6 = ''
          this.dancer7 = ''
          this.dancer8 = ''
          this.dancer9 = ''
          this.dancer10 = ''
          this.dancer11 = ''
          this.dancer12 = ''
        } catch (e) {
          this.saveError = (e && e.message) || 'Could not save this piece.'
        }
        this.saving = false
      }
    }
  }
</script>
